/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Sync_PendingInputs */

const en_us2_draft_sync_pending = /** @type {(inputs: Draft_Sync_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your last plan changes are still being sent. Try accepting again once you are back online.`)
};

const pt_br2_draft_sync_pending = /** @type {(inputs: Draft_Sync_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda enviando suas últimas alterações no plano. Tente aceitar de novo assim que a conexão voltar.`)
};

const es_419_draft_sync_pending = /** @type {(inputs: Draft_Sync_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tus últimos cambios en el plan todavía se están enviando. Intenta aceptar de nuevo cuando vuelvas a tener conexión.`)
};

const pt_pt2_draft_sync_pending = /** @type {(inputs: Draft_Sync_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As tuas últimas alterações ao plano ainda estão a ser enviadas. Tenta aceitar outra vez assim que a ligação voltar.`)
};

const fr_fr2_draft_sync_pending = /** @type {(inputs: Draft_Sync_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tes derniers changements du programme sont encore en cours d'envoi. Réessaie d'accepter une fois de retour en ligne.`)
};

const de_de2_draft_sync_pending = /** @type {(inputs: Draft_Sync_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine letzten Planänderungen werden noch gesendet. Versuch es erneut, sobald du wieder online bist.`)
};

const it_it2_draft_sync_pending = /** @type {(inputs: Draft_Sync_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le ultime modifiche alla scheda sono ancora in invio. Riprova ad accettare quando torni online.`)
};

/**
* | output |
* | --- |
* | "Your last plan changes are still being sent. Try accepting again once you are back online." |
*
* @param {Draft_Sync_PendingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const draft_sync_pending = /** @type {((inputs?: Draft_Sync_PendingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Sync_PendingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_draft_sync_pending(inputs)
	if (locale === "es-419") return es_419_draft_sync_pending(inputs)
	if (locale === "pt-PT") return pt_pt2_draft_sync_pending(inputs)
	if (locale === "fr-FR") return fr_fr2_draft_sync_pending(inputs)
	if (locale === "de-DE") return de_de2_draft_sync_pending(inputs)
	if (locale === "it-IT") return it_it2_draft_sync_pending(inputs)
	return en_us2_draft_sync_pending(inputs)
});
export { draft_sync_pending as "draft.sync_pending" }